import type { MapEventBus } from "../../core/MapEventBus";

export class PdarsSelection {
  private selectedTarget = new Set<string>();

  constructor(private eventBus: MapEventBus) {
    this.setupListeners();
  }

  private setupListeners() {
    // Listen to click events
    this.eventBus.on("pdar:clicked", ({ pdar_id }) => {
      this.toggle(pdar_id);
    });
  }

  private toggle(track_id: string) {
    if (this.selectedTarget.has(track_id)) {
      // Same aircraft - deselect
      this.deselect(track_id);
    } else {
      // Different aircraft - select
      this.select(track_id);
    }
  }

  private select(pdar_id: string) {
    this.selectedTarget.add(pdar_id);

    console.log("[PdarsSelection] Selected:", pdar_id);
    this.eventBus.emit("pdar:selected", { pdar_id });
  }

  private deselect(pdar_id: string) {
    if (!this.selectedTarget) return;

    this.selectedTarget.delete(pdar_id);

    console.log("[PdarsSelection] Deselected:", pdar_id);
    this.eventBus.emit("pdar:deselected", { pdar_id });
  }

  // Public API
  getSelected(): string[] | null {
    return Array.from(this.selectedTarget.values());
  }

  isSelected(pdar_id: string): boolean {
    return this.selectedTarget.has(pdar_id);
  }

  // Programmatic control
  selectAircraft(pdar_id: string) {
    if (!this.selectedTarget.has(pdar_id)) {
      this.select(pdar_id);
    }
  }

  deselectAircraft(pdar_id: string) {
    this.deselect(pdar_id);
  }

  toggleAircraft(pdar_id: string) {
    this.toggle(pdar_id);
  }

  destroy() {
    this.selectedTarget.clear();
  }
}
